var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Loading',{attrs:{"heading":"Logging in","description":"Wait before we redirect you!"}})
}
var staticRenderFns = []

export { render, staticRenderFns }